<template>
	<div class="min-h-screen relative">

		<div
			class="absolute inset-0 h-full w-full z-[-1]"
			style="mask-image:linear-gradient(transparent, black 75%, black);
				background-image: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2032%2032%22%20width%3D%2232%22%20height%3D%2232%22%20fill%3D%22none%22%20stroke%3D%22rgb%2815%2023%2042%20%2F%200.04%29%22%3E%3Cpath%20d%3D%22M0%20.5H31.5V32%22%2F%3E%3C%2Fsvg%3E);
				background-repeat: repeat;"
		>
		</div>

		<!-- Rebrand banner -->
		<div class="relative isolate flex items-center justify-center gap-x-6 overflow-hidden bg-slate-50 border-b px-6 py-2.5 sm:px-3.5">
			<p class="text-sm/6 text-gray-800 flex">

				<svg viewBox="65.275 34.324 292.772 110.06" xmlns="http://www.w3.org/2000/svg"
					 class="block h-5 fill-slate-600 pr-2">
					<path
						d="M157.54612 38.3385c-2.1 2.1-5.1 4.2-6.6 4.5-5.3 1.2-7.7 4-8.4 9.9l-.7 5.5-8.5 4c-8 3.8-8.8 4-17.1 3.9-14.7-.2-33 7-39.7 15.7-6.8 9-9.7 20.2-11 42.3-.8 14.6-.2 16.3 6.9 18.1 2.5.6 10 1.1 16.8 1 6.8 0 14.7 0 17.5.1 6.3.1 9.3-1.3 9.3-4.3 0-3.3-1.1-4.4-6.2-6.6-4.9-2.1-6.4-4.5-5.4-8.6.9-3.4 2.6-4.1 16.1-5.9 6.6-.9 13.4-1.9 15.1-2.1 4.1-.7 6.4 2 9.9 11.5 4.8 13 9.3 17 19.2 17 8.5 0 10.7-3.3 8.2-12.3-.8-2.9-1.9-4.1-4.7-5.5l-3.7-1.8.2-7.4c.6-17.8 5.1-30.4 13-36.5 4-3.1 12.4-6.5 15.8-6.5 1.3 0 5.5-7 5.5-9.1 0-.8-2-2.7-4.4-4.2-5.5-3.5-6.7-4.9-7.5-9-.5-2.8-1.5-3.6-8.8-7.2-4.6-2.2-9.6-5.5-11.2-7.3-1.7-1.7-3.6-3.2-4.3-3.2-.8 0-3.1 1.8-5.3 4zM247.54612 37.3385c-1.7 3.3-3.5 4.5-8.5 5.4-5.6 1-9.7 4.1-12.4 9.3-1.6 3.3-3.7 5.5-6.5 7.1-4 2.3-4.5 3.1-4.1 6.2.3 2.7 7.4 9 11.2 10.2 2.1.6 3.8 1.4 3.8 1.8 0 1-13.6 3-20.9 3-5.3 0-7.4.4-9.2 1.9-4.4 3.6-1.7 4.6 35.6 12.9 7.8 1.7 7.9 1.8 8.7 5.2.4 1.9 1.1 9.4 1.4 16.6.7 12.5.6 13.2-1.5 15.3-1.1 1.1-3.2 2.1-4.6 2.1-3.2 0-6.3 4.3-4.5 6.5 1.9 2.2 7.8 3.8 12.7 3.2 7.9-.9 12.6-5.9 16.4-17.5 3.2-10 3-9.9 15-8 5.6.9 10.8 2.3 11.5 3 .7.7 2 2.9 2.8 4.9l1.5 3.7-5.7 2.8c-4.1 2.1-5.7 3.5-5.7 4.9 0 1.7.9 2.1 7 2.7 13.1 1.2 23.8-3.7 21.4-9.8-1.2-3.3-1.2-5.4.1-5.4.6 0 3.5 2 6.4 4.4 5.7 4.6 11.7 6.6 20.1 6.6 4.8 0 6.3 1.1 4 3-4.9 4 3.8 7 10.4 3.5 3.4-1.7 4.1-3.3 4.1-8.9 0-8.9-3.8-15.2-9.9-16.2-8.2-1.4-7.9-.9-11.1-15.7-4.5-20.6-13.8-28.2-39.3-32.2-11.4-1.7-17.2-3.7-23.5-8-3.5-2.4-3.7-2.8-3.7-7.9 0-6.3-1.9-9.1-7-10-2.1-.4-4.3-1.9-6-3.9-1.4-1.8-3-3.8-3.6-4.5-1.8-2.2-4.8-1.3-6.4 1.8z"></path>
				</svg>

				<span class="text-slate-700"><strong class="font-semibold">SlideCub </strong> has a new look!</span><span class="md:block hidden text-slate-500 ml-2">You may need to login and reauthenticate to use new features.</span>

			</p>
		</div>

		<!-- Navigation -->
		<Navigation :auth="attrs.auth"/>

		<!-- Hero Section -->
		<main class="container mx-auto px-6 pt-10 sm:pt-20 pb-16">

			<div class="flex justify-center pb-6">
				<div class="ring-1 ring-gray-900/10 hover:ring-gray-900/20 bg-slate-200/60 p-1 px-4 rounded-full text-xs flex">
					<span class="pr-2">Designed for Google Slides</span>
					<svg class="size-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 256 256"><path fill="#F4B400" d="M0 30C0 13.431 13.431 0 30 0h196c16.569 0 30 13.431 30 30v196c0 16.569-13.431 30-30 30H30c-16.569 0-30-13.431-30-30V30Z"/><path fill="#fff" d="M28 71h200v114H28V71Z"/></svg>
				</div>
			</div>


			<div class="max-w-4xl mx-auto text-center">
				<h1 class="text-5xl sm:text-6xl font-funnel leading-tight text-gray-900 mb-8">
					AI Presentation Review
				</h1>
				<h2 class="text-xl text-gray-600 mb-12 max-w-2xl mx-auto font-dmsans" v-html="displayedText + (showCursor ? '⬤' : '')">
				</h2>


				<div v-if="presentationURLValidationHasError" class="text-sm text-red-600 my-2">{{ presentationURLValidationError }}</div>

				<div v-if="drivePickerOpen || drivePickerAlreadyOpened">
<!--					<button @click="openPicker">Open Google Drive Picker</button>-->

					<GoogleDrivePicker
						:user="attrs.auth?.user"
						:clientId="props.google_client_id"
						:auth-token="auth_token"
						:presentationURL="presentationURL"
						:open="drivePickerOpen"
						@guest-user-started=""
						@presentation-selected="startAIReview"
						@opened-successfully="drivePickerOpen = false"
						@picker-opened="closeAllModals"
					/>

				</div>

				<div class="flex">

					<div :class="isPresentationURLValid ? 'bg-green-50 ring-gray-900/10' : presentationURLValidationHasError ? 'bg-white ring-red-400 ' : 'bg-white ring-gray-900/10'"
						 class="flex hover:ring-gray-900/20 justify-center mx-auto relative ring-1 rounded-full text-xs w-full sm:w-fit">
						<input v-model='presentationURL' :class="isPresentationURLValid ? 'bg-green-50' : 'bg-transparent'" type="url" name="url" id="url" class="block border-0 border-transparent focus:border-transparent focus:ring-0 outline-hidden pl-14 placeholder:text-gray-400 py-1.5 rounded-none sm:leading-6 sm:text-sm text-gray-900 w-full sm:w-80"
							   :placeholder="screenSize >= 768 ? 'Paste a Google Slides Presentation URL...' : 'Paste Slides URL'">
						<div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-6">

							<!-- URL/ Link Icon  -->
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5  text-gray-400">
									<path d="M12.232 4.232a2.5 2.5 0 0 1 3.536 3.536l-1.225 1.224a.75.75 0 0 0 1.061 1.06l1.224-1.224a4 4 0 0 0-5.656-5.656l-3 3a4 4 0 0 0 .225 5.865.75.75 0 0 0 .977-1.138 2.5 2.5 0 0 1-.142-3.667l3-3Z" />
									<path d="M11.603 7.963a.75.75 0 0 0-.977 1.138 2.5 2.5 0 0 1 .142 3.667l-3 3a2.5 2.5 0 0 1-3.536-3.536l1.225-1.224a.75.75 0 0 0-1.061-1.06l-1.224 1.224a4 4 0 1 0 5.656 5.656l3-3a4 4 0 0 0-.225-5.865Z" />
								</svg>
						</div>



						<button @click="validateAndOpenPreflightModal" :disabled="pickerLoading" type="button" class="w-24 bg-gray-900 hover:bg-gray-700 gap-x-1.5 inline-flex items-center m-2 px-3 py-2 relative ring-1 ring-gray-300 rounded-full text-sm text-white whitespace-nowrap">

							<span v-if="pickerLoading" class="flex justify-center w-full">
								<svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
									<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
									<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
								</svg>
							</span>
							<span v-else class="flex justify-between w-full">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.3 78" class="size-5 mr-2">
									<path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z" fill="#0066da"/>
									<path d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z" fill="#00ac47"/>
									<path d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z" fill="#ea4335"/>
									<path d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d"/>
									<path d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc"/>
									<path d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00"/>
								</svg>
								Find
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
									<path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
								</svg>
							</span>



						</button>
					</div>

				</div>


				<p class="text-xs text-gray-400 pt-2 flex justify-center text-center flex-col sm:flex-row items-center sm:space-x-1">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="size-[0.8rem] mt-px hidden sm:inline">
						<path fill-rule="evenodd" d="M8 1a3.5 3.5 0 0 0-3.5 3.5V7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7V4.5A3.5 3.5 0 0 0 8 1Zm2 6V4.5a2 2 0 1 0-4 0V7h4Z" clip-rule="evenodd" />
					</svg>
					<span class="pl-px">
						We know presentations are sensitive.
						<Link href="/privacy" class="underline block sm:inline">We take privacy seriously.</Link>
					</span>
				</p>


				<!-- Never been here, ask for permissions -->
				<Dialog v-model:open="preAuthGuideOpen">

					<DialogContent class="sm:max-w-md">
						<DialogDescription />

						<ApplicationLogo class="size-10"/>

						<DialogHeader>
							<DialogTitle v-if="!attrs.auth?.user?.name" class="font-funnel text-4xl flex">Give SlideCub access to your presentation.</DialogTitle>
							<DialogTitle v-else class="font-funnel text-4xl flex">{{attrs.auth.user.name.split(" ")[0] + ", looks like your auth expired. Let's reconnect first."}}</DialogTitle>
						</DialogHeader>


						<Button @click="drivePickerOpen = true" data-heap="start-google-auth-presentation-review" class="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
							<svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="24" height="24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/><path fill="none" d="M1 1h22v22H1z"/></svg>

							Continue with Google
						</Button>

						<p class="pt-2 text-xs text-gray-500">After you select your Google Account, SlideCub will request a handful of permissions to necessary to work with your Slides presentations.</p>


						<Accordion type="single" collapsible>
							<AccordionItem value="item-1">
								<AccordionTrigger>What permissions does SlideCub need?</AccordionTrigger>
								<AccordionContent>
									<div class="gap-1 px-4">
										<p class="text-sm text-gray-800 font-normal">
											To access your presentation as SlideCub...
										</p>
										<div class="flex items-start gap-4 p-4">
											<div class="flex-shrink-0 mt-1">
												<div class="flex items-center justify-center rounded">
													<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.3 78" class="size-5">
														<path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z" fill="#0066da"/>
														<path d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z" fill="#00ac47"/>
														<path d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z" fill="#ea4335"/>
														<path d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d"/>
														<path d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc"/>
														<path d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00"/>
													</svg>
												</div>
											</div>
											<div>

												<p class="text-xs text-gray-500 font-normal">
													See, edit, create, and delete only specific files you use with this app.
												</p>

											</div>
										</div>

										<p class="text-sm text-gray-800 font-normal">
											To add comments into your presentation...
										</p>
										<div class="flex items-start gap-4 p-4">
											<div class="flex-shrink-0 mt-1">
												<div class="flex items-center justify-center rounded">
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 39 54" class="size-5">
														<path fill="#F29900" d="M25.594.208 39 13.614l-6.703 1.22-6.703-1.22-1.219-6.093L25.594.208Z"/>
														<path fill="#FBBC04" d="M25.594 13.614V.208H3.656A3.655 3.655 0 0 0 0 3.864v46.313a3.655 3.655 0 0 0 3.656 3.656h31.688A3.655 3.655 0 0 0 39 50.177V13.614H25.594Z"/>
														<path fill="#fff" d="M7.313 20.927V37.38h24.375V20.927H7.313ZM28.64 34.333H10.359v-10.36h18.282v10.36Z"/>
													</svg>
												</div>
											</div>
											<div>

												<p class="text-xs text-gray-500 font-normal">
													See, edit, create, and delete all your Google Slides presentations.
												</p>

												<div class="flex items-start gap-2 p-2 bg-gray-100 rounded-lg text-gray-500 mr-4 mt-2">
													<div class="flex shrink-0">
														<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="size-4">
															<path fill-rule="evenodd" d="M3.28 2.22a.75.75 0 0 0-1.06 1.06l10.5 10.5a.75.75 0 1 0 1.06-1.06l-1.322-1.323a7.012 7.012 0 0 0 2.16-3.11.87.87 0 0 0 0-.567A7.003 7.003 0 0 0 4.82 3.76l-1.54-1.54Zm3.196 3.195 1.135 1.136A1.502 1.502 0 0 1 9.45 8.389l1.136 1.135a3 3 0 0 0-4.109-4.109Z" clip-rule="evenodd" />
															<path d="m7.812 10.994 1.816 1.816A7.003 7.003 0 0 1 1.38 8.28a.87.87 0 0 1 0-.566 6.985 6.985 0 0 1 1.113-2.039l2.513 2.513a3 3 0 0 0 2.806 2.806Z" />
														</svg>

													</div>
													<p class="text-xs">
														Don't worry, SlideCub will only be able to see presentations you explicitly share.
													</p>
												</div>

											</div>
										</div>
									</div>
								</AccordionContent>
							</AccordionItem>
							<AccordionItem value="item-2">
								<AccordionTrigger>What is your pricing?</AccordionTrigger>
								<AccordionContent>
									During the beta period, you may use SlideCub AI review for free. SlideCub will only review the first 10 non-skipped slides in your presentation.
								</AccordionContent>
							</AccordionItem>
							<AccordionItem value="item-3">
								<AccordionTrigger>What happens to my shared presentation?</AccordionTrigger>
								<AccordionContent class="text-xs">
									SlideCub understands presentations can be sensitive. Please don't share anything you aren't comfortable with. <br><br>
									When you do, we authenticate with Google on your behalf to secure view your presentation. Your slides are then processed through Google Gemini, with feedback added directly into your presentation. <br><br>
									We don't publish or share your presentation, but we may use it to improve our services. We may store slide thumbnails, metadata, and other usage statistics to improve your experience. <br><br>
									You can read our <a href="/terms"> Terms of Service</a> and <a href="/privacy">Privacy Policy</a> for further detail.
								</AccordionContent>
							</AccordionItem>
						</Accordion>






						<DialogFooter class="sm:justify-start">
							<DialogClose as-child>
								<Button type="button" variant="secondary">
									Close
								</Button>
							</DialogClose>
						</DialogFooter>
					</DialogContent>
				</Dialog>

				<!-- Have been here before, just needs to prompt login -->
				<Dialog v-model:open="reviewPreflightModalOpen">

					<DialogContent class="sm:max-w-md">

						<ApplicationLogo class="size-10"/>

						<DialogHeader>
							<DialogTitle class="font-funnel text-4xl flex">Looks like you've been here before. Login first.</DialogTitle>
						</DialogHeader>


						<Link href="/login" class="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
							<ApplicationLogo class="size-6 mr-2"/>
							Login with SlideCub
						</Link>

						<p class="pt-2 text-sm text-gray-600">After you login successfully, come back to the homepage to start your AI presentation review.</p>

						<hr>

						<h3 class="font-funnel text-xl flex">First time user?</h3>
						<p class="pt-2 text-sm text-gray-600">Use this link to start the authentication process.</p>
						<button @click="preAuthGuideOpen = true; reviewPreflightModalOpen = false;" class="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
							Get Started
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
								<path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
							</svg>

						</button>



						<DialogFooter class="sm:justify-start mt-2">
							<DialogClose as-child>
								<Button type="button" variant="secondary">
									Close
								</Button>
							</DialogClose>
						</DialogFooter>
					</DialogContent>
				</Dialog>


				<Dialog v-model:open="reviewStartedModalOpen">

					<DialogContent class="sm:max-w-md">

						<ApplicationLogo class="size-10"/>

						<DialogHeader>
							<DialogTitle class="font-funnel text-4xl flex">{{presentationMetadata.message}}</DialogTitle>
							<p class="text-xs p-2 bg-red-200 rounded-xl" v-if="presentationMetadata.warning">{{presentationMetadata.warning}}</p>
							<p v-else class="text-xs">It might take up to a minute for comments to start appearing.</p>
						</DialogHeader>

						<div class="-mb-3 flex group text-gray-700">
							<a :href="presentationMetadata.url" target="_blank" rel="noopener noreferrer">
								<div class="text-sm hover:underline">{{ presentationMetadata.title }}</div>
							</a>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="size-[0.8rem] group-hover:translate-x-px group-hover:-translate-y-px transform ease-out duration-300 transition ">
								<path fill-rule="evenodd" d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd" />
							</svg>

						</div>
						<div class="flex gap-4">
							<div class="w-1/2 relative">
								<transition mode="out-in">
									<a :href="presentationMetadata.url" target="_blank" rel="noopener noreferrer">
										<img v-if="presentationThumbnail"
											 class="border-2 border-slate-300 w-full rounded-lg opacity-0 transition-opacity duration-300 ease-in-out"
											 :src="presentationThumbnail"
											 onload="this.style.opacity=1"
										>

										<div v-else class="animate-pulse bg-slate-200 border-2 border-slate-300 pb-[56.25%] rounded-lg"></div>
									</a>
								</transition>
							</div>
							<div class="flex-1 space-y-2">
								<div class="text-gray-400 text-xs">Last Edited</div>
								<div class="text-gray-400 text-xs">{{ presentationMetadata.lastEditedLocal }}</div>
								<div class="text-gray-400 text-xs" v-if="presentationMetadata.slide_count">{{ presentationMetadata.slide_count }} slide{{ presentationMetadata.slide_count === 0 ? '' : 's' }}
									 {{ presentationMetadata.skipped_slides === 0 ? '' : ' | ' + presentationMetadata.skipped_slides + ' skipped' }}
								</div>

							</div>
						</div>

						<p class="pt-2 text-xs text-gray-500">During this early access period, you will not be billed. SlideCub will only review the first 10 non-hidden slides in your presentation.</p>




						<DialogFooter class="sm:justify-start">
							<DialogClose as-child>
								<Button type="button" variant="secondary">
									Close
								</Button>
							</DialogClose>
						</DialogFooter>
					</DialogContent>
				</Dialog>


			</div>




			<!-- GSlides Animated Mockup -->
			<div class="mt-20 relative max-w-5xl mx-auto">
				<div class="relative">

					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1397 649">
						<rect width="1072" height="576" x="54" y="44" fill="#F9FBFD" stroke="#E8F0FE" stroke-width="2" rx="14"/>
						<rect width="969" height="32" x="121" y="77" fill="#EEF3FA" rx="16"/>
						<path fill="#656565" d="M100.506 268v-1.278l4.801-5.256a33.368 33.368 0 0 0 1.392-1.605c.364-.459.634-.89.81-1.293.179-.407.269-.833.269-1.278 0-.511-.123-.954-.369-1.328a2.399 2.399 0 0 0-.994-.867 3.234 3.234 0 0 0-1.421-.305c-.558 0-1.046.116-1.463.348a2.399 2.399 0 0 0-.959.959c-.222.412-.333.895-.333 1.449h-1.677c0-.853.197-1.601.59-2.245a4.088 4.088 0 0 1 1.605-1.505c.682-.36 1.447-.54 2.294-.54.852 0 1.608.18 2.266.54a4.051 4.051 0 0 1 1.548 1.456c.374.61.561 1.29.561 2.038 0 .535-.097 1.058-.291 1.57-.189.506-.521 1.072-.994 1.697-.469.62-1.12 1.378-1.954 2.273l-3.267 3.494v.114h6.762V268h-9.176ZM105.42 388.199c-.937 0-1.773-.161-2.507-.483-.729-.322-1.309-.769-1.74-1.342-.426-.578-.658-1.248-.696-2.01h1.79c.038.469.199.873.483 1.214.284.336.656.597 1.115.782a4.07 4.07 0 0 0 1.527.277c.625 0 1.179-.109 1.662-.327.483-.218.862-.521 1.136-.909.275-.389.412-.838.412-1.35 0-.535-.132-1.006-.397-1.413-.266-.412-.654-.734-1.165-.966-.512-.232-1.137-.348-1.875-.348H104v-1.562h1.165c.577 0 1.084-.105 1.52-.313.44-.208.783-.502 1.03-.881.25-.378.376-.824.376-1.335 0-.492-.109-.921-.327-1.285a2.235 2.235 0 0 0-.923-.853c-.393-.203-.857-.305-1.392-.305-.502 0-.975.092-1.421.277-.44.18-.8.443-1.079.788-.279.341-.431.753-.455 1.236h-1.704c.028-.762.258-1.43.689-2.003a4.342 4.342 0 0 1 1.69-1.349 5.462 5.462 0 0 1 2.308-.483c.9 0 1.672.182 2.316.547.644.36 1.138.835 1.484 1.427.346.592.518 1.231.518 1.918 0 .819-.215 1.517-.646 2.095-.426.578-1.006.978-1.74 1.2v.114c.919.152 1.636.542 2.152 1.172.516.625.774 1.399.774 2.322 0 .791-.215 1.501-.646 2.131-.426.625-1.009 1.117-1.747 1.477-.739.36-1.579.54-2.522.54ZM101.165 505.017v-1.449l6.392-10.114h1.051v2.244h-.71l-4.83 7.642v.114h8.608v1.563h-10.511Zm6.846 2.983v-14.546h1.677V508h-1.677Z"/>
						<path fill="#ECD2EB" d="M479.006 131H336c-8.284 0-15 6.716-15 15v103.001l.5-.001c61.027 0 110.5 49.473 110.5 110.5S382.527 470 321.5 470l-.5-.001V572c0 8.284 6.716 15 15 15h144.444C552.126 536.826 599 453.637 599 359.5c0-94.766-47.502-178.436-119.994-228.5Z"/>
						<path fill="url(#a)" d="M479.006 131H336c-8.284 0-15 6.716-15 15v103.001l.5-.001c61.027 0 110.5 49.473 110.5 110.5S382.527 470 321.5 470l-.5-.001V572c0 8.284 6.716 15 15 15h144.444C552.126 536.826 599 453.637 599 359.5c0-94.766-47.502-178.436-119.994-228.5Z"/>
						<path fill="#E4DDFC" d="M480.444 587H1077c8.28 0 15-6.716 15-15V146c0-8.284-6.72-15-15-15H479.006C551.091 181.336 599 264.911 599 359.5c0 93.966-47.274 177.062-118.556 227.5Z"/>
						<path fill="#E4DDFC" d="M480.444 587H1077c8.28 0 15-6.716 15-15V146c0-8.284-6.72-15-15-15H479.006C551.091 181.336 599 264.911 599 359.5c0 93.966-47.274 177.062-118.556 227.5ZM321.5 470l-.5-.001V249.001l.5-.001C383 249 432 299.024 432 359.5S383 470 321.5 470Z"/>
						<rect width="279" height="20" x="706" y="295" fill="#F1EEFD" rx="10"/>
						<rect width="170" height="20" x="706" y="331" fill="#F1EEFD" rx="10"/>
						<rect width="216" height="20" x="706" y="367" fill="#F1EEFD" rx="10"/>
						<rect width="234" height="20" x="706" y="403" fill="#F1EEFD" rx="10"/>
						<rect width="173" height="96" x="122" y="370" fill="#EEF5FF" stroke="#EBEBEB" stroke-width="2" rx="14"/>
						<path fill="#D6E6FF" d="M127 438c36.451 0 66-29.55 66-66 0-.334-.003-.667-.007-1H136.5c-7.5 0-13.5 5.5-13.5 13.5v53.38c1.323.079 2.657.12 4 .12Z"/>
						<circle cx="234" cy="418.999" r="43" fill="#E0ECFD"/>
						<rect width="172.092" height="100.821" x="122" y="485" fill="#FAF7F0" stroke="#EBEBEB" stroke-width="2" rx="14"/>
						<path fill="#FAF5E6" d="M222.502 515.366h70.59v54.455c0 8.285-6.716 15-15 15h-55.59v-69.455Z"/>
						<path fill="#FAEFD6" d="M180.884 558 160 486h90l-69.116 72Z"/>
						<path fill="#ECD2EB" d="M156.864 247.001H131.5c-1.88 0-10.5 8.62-10.5 10.5v16.284l.113-.001c13.852 0 25.082 11.23 25.082 25.081 0 13.852-11.23 25.082-25.082 25.082l-.113-.001V340c0 1.88 7.12 10.503 9 10.503h27.19c16.27-11.388 26.91-30.271 26.91-51.638 0-21.509-10.782-40.5-27.236-51.864Z"/>
						<path fill="url(#b)" d="M156.864 247.001H131.5c-1.88 0-10.5 8.62-10.5 10.5v16.284l.113-.001c13.852 0 25.082 11.23 25.082 25.081 0 13.852-11.23 25.082-25.082 25.082l-.113-.001V340c0 1.88 7.12 10.503 9 10.503h27.19c16.27-11.388 26.91-30.271 26.91-51.638 0-21.509-10.782-40.5-27.236-51.864Z"/>
						<path fill="#E4DDFC" d="M157.19 350.503H287c1.88 0 9-8.623 9-10.503v-82.5c0-3.381-3.5-6.38-15-10.499H156.864c16.362 11.425 27.236 30.395 27.236 51.864 0 21.329-10.73 40.19-26.91 51.638Z"/>
						<path fill="#E4DDFC" d="M157.19 350.503H287c1.88 0 9-8.623 9-10.503v-82.5c0-3.381-3.5-6.38-15-10.499H156.864c16.362 11.425 27.236 30.395 27.236 51.864 0 21.329-10.73 40.19-26.91 51.638ZM121.113 323.947l-.113-.001v-50.161l.113-.001c13.96 0 25.082 11.355 25.082 25.081 0 13.727-11.122 25.082-25.082 25.082Z"/>
						<rect width="63.327" height="4.54" x="208.386" y="284.226" fill="#F1EEFD" rx="2.27"/>
						<rect width="38.586" height="4.54" x="208.386" y="292.396" fill="#F1EEFD" rx="2.27"/>
						<rect width="49.027" height="4.54" x="208.386" y="300.567" fill="#F1EEFD" rx="2.27"/>
						<rect width="53.113" height="4.54" x="208.386" y="308.739" fill="#F1EEFD" rx="2.27"/>
						<rect width="172" height="101" x="122.5" y="248.501" stroke="#5C8FDF" stroke-width="3" rx="8.5"/>
						<rect width="173" height="101.502" x="122" y="127" fill="#FFF4D7" stroke="#EBEBEB" stroke-width="2" rx="14"/>
						<rect width="119.163" height="7.036" x="148.918" y="170.715" fill="#fff" rx="3.518"/>
						<rect width="119" height="6.966" x="149" y="182.727" fill="#fff" rx="3.483"/>
						<g filter="url(#c)">
							<rect width="600" height="149" x="7" y="3" fill="#F7F9FD" rx="14"/>
						</g>
						<rect width="50.355" height="29.901" x="129.703" y="89" fill="#EBEBEB" rx="7"/>
						<rect width="50.355" height="29.901" x="210" y="89" fill="#EBEBEB" rx="7"/>
						<rect width="50.355" height="29.901" x="290" y="89" fill="#EBEBEB" rx="7"/>
						<rect width="75.532" height="29.901" x="370" y="89" fill="#EBEBEB" rx="7"/>
						<rect width="98" height="30" x="475" y="89" fill="#EBEBEB" rx="7"/>
						<path fill="#F29900" d="m86.273 33.866 17.429 17.429-8.715 1.584-8.714-1.584-1.584-7.922 1.584-9.507Z"/>
						<path fill="#FBBC04" d="M86.273 51.295V33.866h-28.52A4.752 4.752 0 0 0 53 38.62v60.208a4.752 4.752 0 0 0 4.753 4.753H98.95a4.752 4.752 0 0 0 4.753-4.753V51.295H86.273Z"/>
						<path fill="#fff" d="M62.507 60.802v21.39h31.688v-21.39H62.507ZM90.234 78.23H66.468V64.763h23.766V78.23Z"/>
						<text ref="textElement" xml:space="preserve" fill="#3F3F3F" font-family="DM Sans" font-size="32" letter-spacing="0em" opacity=".75" style="white-space:pre"><tspan x="134" y="64.136">{{ presentationTitlesvg }}</tspan></text>
						<g ref="groupD" filter="url(#d)">
							<rect width="283" height="164" x="1110" y="131" fill="#EDF2FA" rx="15"/>
							<circle cx="1143.5" cy="165.5" r="16.5" fill="#fff"/>
							<rect width="224" height="17" x="1127" y="200" fill="#E2E2E2" rx="8.5"/>
							<rect width="224" height="17" x="1127" y="221" fill="#E2E2E2" rx="8.5"/>
							<rect width="224" height="17" x="1127" y="242" fill="#E2E2E2" rx="8.5"/>
							<rect width="41" height="12" x="1127" y="266" fill="#2972DB" rx="6"/>
							<path fill="#565656" d="M1245.24 173v-14.546h1.68v5.369h.14c.12-.189.29-.43.51-.724.22-.298.54-.563.95-.795.42-.237.98-.356 1.69-.356.92 0 1.73.23 2.43.689.7.46 1.25 1.111 1.64 1.953.4.843.59 1.838.59 2.983 0 1.156-.19 2.157-.59 3.005-.39.842-.93 1.496-1.63 1.96-.7.459-1.5.689-2.41.689-.7 0-1.26-.116-1.68-.348-.42-.237-.75-.504-.97-.803a9.26 9.26 0 0 1-.53-.753h-.2V173h-1.62Zm1.65-5.455c0 .824.12 1.551.36 2.18.24.625.6 1.115 1.06 1.471.46.35 1.03.525 1.7.525.71 0 1.29-.185 1.76-.554.47-.374.83-.876 1.06-1.506.25-.634.37-1.339.37-2.116 0-.767-.12-1.458-.36-2.074-.23-.62-.58-1.11-1.06-1.47-.47-.365-1.06-.547-1.77-.547-.68 0-1.25.173-1.71.519-.47.34-.82.819-1.06 1.434-.23.611-.35 1.324-.35 2.138ZM1240.27 168.54v-6.449h1.67V173h-1.67v-1.847h-.12c-.25.554-.65 1.025-1.19 1.414-.54.383-1.22.575-2.04.575-.69 0-1.29-.149-1.82-.447-.53-.304-.95-.758-1.25-1.364-.31-.611-.46-1.38-.46-2.308v-6.932h1.68v6.818c0 .795.22 1.43.67 1.903.45.474 1.02.711 1.72.711.41 0 .84-.107 1.27-.32.43-.213.8-.54 1.09-.98.3-.44.45-1.001.45-1.683ZM1230.77 163h-1.76c-.1-.506-.28-.952-.54-1.335a3.694 3.694 0 0 0-.94-.966 4.029 4.029 0 0 0-1.22-.597c-.44-.132-.9-.198-1.39-.198-.88 0-1.68.222-2.39.667-.71.445-1.28 1.101-1.7 1.968-.42.866-.62 1.929-.62 3.188 0 1.26.2 2.323.62 3.189.42.867.99 1.523 1.7 1.968.71.445 1.51.667 2.39.667.49 0 .95-.066 1.39-.199.45-.132.85-.329 1.22-.589a3.652 3.652 0 0 0 1.48-2.308h1.76a5.815 5.815 0 0 1-.72 1.995 5.463 5.463 0 0 1-1.31 1.499c-.52.407-1.1.717-1.75.93-.64.214-1.33.32-2.07.32-1.24 0-2.34-.303-3.31-.909-.96-.606-1.72-1.468-2.28-2.585-.55-1.118-.83-2.443-.83-3.978 0-1.534.28-2.859.83-3.977.56-1.117 1.32-1.979 2.28-2.585.97-.606 2.07-.909 3.31-.909.74 0 1.43.106 2.07.319.65.214 1.23.526 1.75.938.52.407.96.904 1.31 1.491.35.583.59 1.248.72 1.996ZM1211.78 173.228c-1.06 0-1.96-.232-2.72-.696a4.66 4.66 0 0 1-1.76-1.961c-.41-.842-.61-1.823-.61-2.94s.2-2.102.61-2.955c.41-.857.99-1.524 1.72-2.002.74-.483 1.6-.725 2.59-.725.56 0 1.12.095 1.68.284.55.19 1.06.497 1.51.924.46.421.82.98 1.09 1.676.27.696.4 1.553.4 2.571v.71h-8.41v-1.449h6.71c0-.615-.12-1.165-.37-1.648a2.775 2.775 0 0 0-1.04-1.143c-.44-.279-.97-.419-1.57-.419-.67 0-1.25.166-1.74.497-.48.327-.85.753-1.11 1.278a3.763 3.763 0 0 0-.39 1.691v.966c0 .824.14 1.522.42 2.095.29.568.69 1.001 1.2 1.3.51.293 1.11.44 1.79.44.44 0 .83-.062 1.19-.185.36-.128.67-.317.93-.568.26-.256.46-.573.6-.952l1.62.455a3.508 3.508 0 0 1-.86 1.449c-.4.412-.9.734-1.49.966-.59.227-1.26.341-1.99.341ZM1198.9 173.227c-.91 0-1.71-.23-2.41-.689-.69-.464-1.24-1.118-1.63-1.96-.39-.848-.59-1.849-.59-3.005 0-1.145.2-2.14.59-2.983.39-.842.94-1.493 1.64-1.953.7-.459 1.51-.689 2.43-.689.71 0 1.27.119 1.68.356.42.232.74.497.95.795.23.294.4.535.52.724h.14v-5.369h1.68V173h-1.62v-1.677h-.2c-.12.199-.3.45-.52.753-.23.299-.56.566-.98.803-.42.232-.98.348-1.68.348Zm.23-1.506c.67 0 1.24-.175 1.7-.525.47-.356.82-.846 1.06-1.471.24-.629.36-1.356.36-2.18 0-.814-.12-1.527-.35-2.138-.24-.615-.59-1.094-1.05-1.434-.47-.346-1.04-.519-1.72-.519-.71 0-1.31.182-1.78.547-.47.36-.82.85-1.06 1.47a5.892 5.892 0 0 0-.35 2.074c0 .777.12 1.482.36 2.116.24.63.6 1.132 1.07 1.506.47.369 1.06.554 1.76.554ZM1190.03 173v-10.909h1.68V173h-1.68Zm.86-12.727c-.33 0-.61-.112-.85-.334-.23-.223-.35-.49-.35-.803 0-.312.12-.58.35-.802.24-.223.52-.334.85-.334.32 0 .6.111.83.334.24.222.36.49.36.802 0 .313-.12.58-.36.803-.23.222-.51.334-.83.334ZM1186.96 158.454V173h-1.67v-14.546h1.67ZM1180.72 162.091c-.09-.72-.43-1.278-1.04-1.676-.61-.398-1.35-.597-2.23-.597-.65 0-1.21.105-1.69.313-.48.208-.85.495-1.12.859-.27.365-.4.779-.4 1.243 0 .388.09.722.28 1.002.19.274.43.504.72.688.29.18.6.33.92.448.33.114.62.206.89.277l1.48.398c.38.099.8.236 1.26.412.47.175.92.414 1.34.717.44.298.79.682 1.07 1.15.28.469.42 1.044.42 1.726 0 .786-.21 1.497-.62 2.131-.41.634-1 1.139-1.79 1.513-.78.374-1.73.561-2.85.561-1.04 0-1.94-.168-2.7-.504-.76-.337-1.36-.805-1.79-1.407a3.956 3.956 0 0 1-.73-2.095h1.81c.05.549.24 1.004.56 1.364.33.355.74.62 1.23.795.51.171 1.05.256 1.62.256.68 0 1.28-.109 1.81-.327.54-.222.96-.53 1.28-.923.31-.398.46-.862.46-1.392 0-.483-.13-.876-.4-1.179-.27-.303-.63-.549-1.07-.739-.44-.189-.91-.355-1.42-.497l-1.79-.511c-1.14-.327-2.04-.793-2.7-1.399-.66-.606-1-1.4-1-2.38 0-.814.22-1.524.66-2.13.45-.611 1.05-1.085 1.79-1.421.76-.341 1.6-.511 2.53-.511.93 0 1.77.168 2.5.504.72.332 1.3.786 1.73 1.364.43.577.66 1.233.68 1.967h-1.7Z"/>
							<path fill="#E7E7E7" d="m1140.83 173.099 1.76-.829-1.03-2.349-.87 1.575-1.31 2.376 1.45-.773Z"/>
							<path fill="#E9E9E9" d="M1135.24 168.153h3.29l2.16 3.343.87-1.575-.68-5.25-4.77-.58-.87 4.062Z"/>
							<path fill="#D8D8D8" d="m1141.56 169.921 2.3-2.045 2.13-7.322-5.11 4.117.68 5.25Z"/>
							<path fill="#E9E9E9" d="m1145.52 167.876 1.63-4.642-1.16-2.68-2.13 7.322h1.66Z"/>
							<path fill="#EFEFEF" d="m1142.59 172.27 1.56 3.73-.29-8.124-2.3 2.045 1.03 2.349Z"/>
							<path fill="#E2E2E2" d="m1144.15 176 1.68-3.039-.31-5.085h-1.66l.29 8.124Z"/>
							<path fill="#E4E4E4" d="m1147.15 163.234 2.11-.995 2.79.719.61-.608-1.85-1.022-1.39-.774h-3.43l1.16 2.68Z"/>
							<path fill="#DBDBDB" d="m1152.66 162.35.42.138.92-1.16-1.77-2.017-1.42 2.017 1.85 1.022Z"/>
							<path fill="#ECECEC" d="m1149.65 158.592-.23 1.962 1.39.774 1.42-2.017-.44-1.714-2.14.995Z"/>
							<path fill="#E2E2E2" d="m1147.07 155.276 2.58 3.316 2.14-.995-2.59-1.934-2.13-.387Z"/>
							<path fill="#DADADA" d="M1145.99 160.554h3.43l.23-1.962-2.58-3.316-1.55 1.686.47 3.592Z"/>
							<path fill="#D1D1D1" d="M1145.52 155.663v1.299l1.55-1.686-1.47-.276-.08.663Z"/>
							<path fill="#E3E3E3" d="M1140.88 159.034v5.637l5.11-4.117-.47-3.592v-1.299l-4.64 3.371Z"/>
							<path fill="#D8D8D8" d="m1140.88 159.034-4.77 5.057 4.77.58v-5.637Z"/>
							<path fill="#E5E5E5" d="m1133.55 164.588 2.56-.497 4.77-5.057-7.33 5.554Z"/>
							<path fill="#DCDCDC" d="m1135.35 176 4.03-2.128 1.31-2.376-2.16-3.343h-3.29l-3.24 2.984.5 1.271 1.53 3.592h1.32Z"/>
							<path fill="#EEE" d="m1132 171.137 3.24-2.984.87-4.062-2.56.497-1.44 2.542-.11 4.007Z"/>
							<path fill="#D9D9D9" d="m1140.83 176-1.45-2.128-4.03 2.128h5.48Z"/>
							<path fill="#D5D5D5" d="m1144.15 176 3.95-1.768-2.27-1.271-1.68 3.039Z"/>
							<path fill="#E3E3E3" d="M1144.15 176h4.32l-.37-1.768-3.95 1.768ZM1142.25 176h1.9l-1.56-3.73-1.76.829 1.42 2.901Z"/>
							<path stroke="#8A8A8A" stroke-width=".2" d="M1144.15 176h4.32l-.37-1.768m-3.95 1.768 3.95-1.768m-3.95 1.768 1.68-3.039m-1.68 3.039h-1.9l-1.42-2.901m3.32 2.901-1.56-3.73m1.56 3.73-.29-8.124m4.24 6.356-2.27-1.271m0 0-.31-5.085m0 0 1.63-4.642m-1.63 4.642h-1.66m3.29-4.642 2.11-.995 2.79.719.61-.608m-5.51.884-1.16-2.68m6.67 1.796.42.138.92-1.16-1.77-2.017m.43 3.039-1.85-1.022m-1.39-.774h-3.43m3.43 0 .23-1.962m-.23 1.962 1.39.774m-4.82-.774-2.13 7.322m2.13-7.322-5.11 4.117m5.11-4.117-.47-3.592m-4.69 16.137 1.76-.829m-1.76.829-1.45.773m3.21-1.602-1.03-2.349m2.3-2.045-2.3 2.045m0 0-.87 1.575m.87-1.575-.68-5.25m-1.5 9.201 1.45 2.128h-5.48m4.03-2.128-4.03 2.128m4.03-2.128 1.31-2.376m-5.34 4.504h-1.32l-1.53-3.592-.5-1.271m0 0 3.24-2.984m-3.24 2.984.11-4.007 1.44-2.542m1.69 3.565h3.29l2.16 3.343m-5.45-3.343.87-4.062m-2.56.497 2.56-.497m-2.56.497 7.33-5.554m-4.77 5.057 4.77-5.057m-4.77 5.057 4.77.58m0-5.637v5.637m0-5.637 4.64-3.371m0 0v1.299m0-1.299.08-.663 1.47.276m-1.55 1.686 1.55-1.686m0 0 2.58 3.316m-2.58-3.316 2.13.387 2.59 1.934m-2.14.995 2.14-.995m.44 1.714-.44-1.714m.44 1.714-1.42 2.017"/>
						</g>
						<g ref="groupE" filter="url(#e)">
							<rect width="283" height="147" x="1110" y="321" fill="#EDF2FA" rx="15"/>
							<circle cx="1143.5" cy="355.5" r="16.5" fill="#fff"/>
							<rect width="224" height="17" x="1127" y="390" fill="#E2E2E2" rx="8.5"/>
							<rect width="224" height="17" x="1127" y="411" fill="#E2E2E2" rx="8.5"/>
							<rect width="91" height="17" x="1127" y="432" fill="#E2E2E2" rx="8.5"/>
							<path fill="#565656" d="M1245.24 363v-14.546h1.68v5.369h.14c.12-.189.29-.43.51-.724.22-.298.54-.563.95-.795.42-.237.98-.356 1.69-.356.92 0 1.73.23 2.43.689.7.46 1.25 1.111 1.64 1.953.4.843.59 1.838.59 2.983 0 1.156-.19 2.157-.59 3.005-.39.842-.93 1.496-1.63 1.96-.7.459-1.5.689-2.41.689-.7 0-1.26-.116-1.68-.348-.42-.237-.75-.504-.97-.803a9.26 9.26 0 0 1-.53-.753h-.2V363h-1.62Zm1.65-5.455c0 .824.12 1.551.36 2.18.24.625.6 1.115 1.06 1.471.46.35 1.03.525 1.7.525.71 0 1.29-.185 1.76-.554.47-.374.83-.876 1.06-1.506.25-.634.37-1.339.37-2.116 0-.767-.12-1.458-.36-2.074-.23-.62-.58-1.11-1.06-1.47-.47-.365-1.06-.547-1.77-.547-.68 0-1.25.173-1.71.519-.47.34-.82.819-1.06 1.434-.23.611-.35 1.324-.35 2.138ZM1240.27 358.54v-6.449h1.67V363h-1.67v-1.847h-.12c-.25.554-.65 1.025-1.19 1.414-.54.383-1.22.575-2.04.575-.69 0-1.29-.149-1.82-.447-.53-.304-.95-.758-1.25-1.364-.31-.611-.46-1.38-.46-2.308v-6.932h1.68v6.818c0 .795.22 1.43.67 1.903.45.474 1.02.711 1.72.711.41 0 .84-.107 1.27-.32.43-.213.8-.54 1.09-.98.3-.44.45-1.001.45-1.683ZM1230.77 353h-1.76c-.1-.506-.28-.952-.54-1.335a3.694 3.694 0 0 0-.94-.966 4.029 4.029 0 0 0-1.22-.597c-.44-.132-.9-.198-1.39-.198-.88 0-1.68.222-2.39.667-.71.445-1.28 1.101-1.7 1.968-.42.866-.62 1.929-.62 3.188 0 1.26.2 2.323.62 3.189.42.867.99 1.523 1.7 1.968.71.445 1.51.667 2.39.667.49 0 .95-.066 1.39-.199.45-.132.85-.329 1.22-.589a3.652 3.652 0 0 0 1.48-2.308h1.76a5.815 5.815 0 0 1-.72 1.995 5.463 5.463 0 0 1-1.31 1.499c-.52.407-1.1.717-1.75.93-.64.214-1.33.32-2.07.32-1.24 0-2.34-.303-3.31-.909-.96-.606-1.72-1.468-2.28-2.585-.55-1.118-.83-2.443-.83-3.978 0-1.534.28-2.859.83-3.977.56-1.117 1.32-1.979 2.28-2.585.97-.606 2.07-.909 3.31-.909.74 0 1.43.106 2.07.319.65.214 1.23.526 1.75.938.52.407.96.904 1.31 1.491.35.583.59 1.248.72 1.996ZM1211.78 363.228c-1.06 0-1.96-.232-2.72-.696a4.66 4.66 0 0 1-1.76-1.961c-.41-.842-.61-1.823-.61-2.94s.2-2.102.61-2.955c.41-.857.99-1.524 1.72-2.002.74-.483 1.6-.725 2.59-.725.56 0 1.12.095 1.68.284.55.19 1.06.497 1.51.924.46.421.82.98 1.09 1.676.27.696.4 1.553.4 2.571v.71h-8.41v-1.449h6.71c0-.615-.12-1.165-.37-1.648a2.775 2.775 0 0 0-1.04-1.143c-.44-.279-.97-.419-1.57-.419-.67 0-1.25.166-1.74.497-.48.327-.85.753-1.11 1.278a3.763 3.763 0 0 0-.39 1.691v.966c0 .824.14 1.522.42 2.095.29.568.69 1.001 1.2 1.3.51.293 1.11.44 1.79.44.44 0 .83-.062 1.19-.185.36-.128.67-.317.93-.568.26-.256.46-.573.6-.952l1.62.455a3.508 3.508 0 0 1-.86 1.449c-.4.412-.9.734-1.49.966-.59.227-1.26.341-1.99.341ZM1198.9 363.227c-.91 0-1.71-.23-2.41-.689-.69-.464-1.24-1.118-1.63-1.96-.39-.848-.59-1.849-.59-3.005 0-1.145.2-2.14.59-2.983.39-.842.94-1.493 1.64-1.953.7-.459 1.51-.689 2.43-.689.71 0 1.27.119 1.68.356.42.232.74.497.95.795.23.294.4.535.52.724h.14v-5.369h1.68V363h-1.62v-1.677h-.2c-.12.199-.3.45-.52.753-.23.299-.56.566-.98.803-.42.232-.98.348-1.68.348Zm.23-1.506c.67 0 1.24-.175 1.7-.525.47-.356.82-.846 1.06-1.471.24-.629.36-1.356.36-2.18 0-.814-.12-1.527-.35-2.138-.24-.615-.59-1.094-1.05-1.434-.47-.346-1.04-.519-1.72-.519-.71 0-1.31.182-1.78.547-.47.36-.82.85-1.06 1.47a5.892 5.892 0 0 0-.35 2.074c0 .777.12 1.482.36 2.116.24.63.6 1.132 1.07 1.506.47.369 1.06.554 1.76.554ZM1190.03 363v-10.909h1.68V363h-1.68Zm.86-12.727c-.33 0-.61-.112-.85-.334-.23-.223-.35-.49-.35-.803 0-.312.12-.58.35-.802.24-.223.52-.334.85-.334.32 0 .6.111.83.334.24.222.36.49.36.802 0 .313-.12.58-.36.803-.23.222-.51.334-.83.334ZM1186.96 348.454V363h-1.67v-14.546h1.67ZM1180.72 352.091c-.09-.72-.43-1.278-1.04-1.676-.61-.398-1.35-.597-2.23-.597-.65 0-1.21.105-1.69.313-.48.208-.85.495-1.12.859-.27.365-.4.779-.4 1.243 0 .388.09.722.28 1.002.19.274.43.504.72.688.29.18.6.33.92.448.33.114.62.206.89.277l1.48.398c.38.099.8.236 1.26.412.47.175.92.414 1.34.717.44.298.79.682 1.07 1.15.28.469.42 1.044.42 1.726 0 .786-.21 1.497-.62 2.131-.41.634-1 1.139-1.79 1.513-.78.374-1.73.561-2.85.561-1.04 0-1.94-.168-2.7-.504-.76-.337-1.36-.805-1.79-1.407a3.956 3.956 0 0 1-.73-2.095h1.81c.05.549.24 1.004.56 1.364.33.355.74.62 1.23.795.51.171 1.05.256 1.62.256.68 0 1.28-.109 1.81-.327.54-.222.96-.53 1.28-.923.31-.398.46-.862.46-1.392 0-.483-.13-.876-.4-1.179-.27-.303-.63-.549-1.07-.739-.44-.189-.91-.355-1.42-.497l-1.79-.511c-1.14-.327-2.04-.793-2.7-1.399-.66-.606-1-1.4-1-2.38 0-.814.22-1.524.66-2.13.45-.611 1.05-1.085 1.79-1.421.76-.341 1.6-.511 2.53-.511.93 0 1.77.168 2.5.504.72.332 1.3.786 1.73 1.364.43.577.66 1.233.68 1.967h-1.7Z"/>
							<path fill="#E7E7E7" d="m1141.83 363.099 1.76-.829-1.03-2.349-.87 1.575-1.31 2.376 1.45-.773Z"/>
							<path fill="#E9E9E9" d="M1136.24 358.153h3.29l2.16 3.343.87-1.575-.68-5.25-4.77-.58-.87 4.062Z"/>
							<path fill="#D8D8D8" d="m1142.56 359.921 2.3-2.045 2.13-7.322-5.11 4.117.68 5.25Z"/>
							<path fill="#E9E9E9" d="m1146.52 357.876 1.63-4.642-1.16-2.68-2.13 7.322h1.66Z"/>
							<path fill="#EFEFEF" d="m1143.59 362.27 1.56 3.73-.29-8.124-2.3 2.045 1.03 2.349Z"/>
							<path fill="#E2E2E2" d="m1145.15 366 1.68-3.039-.31-5.085h-1.66l.29 8.124Z"/>
							<path fill="#E4E4E4" d="m1148.15 353.234 2.11-.995 2.79.719.61-.608-1.85-1.022-1.39-.774h-3.43l1.16 2.68Z"/>
							<path fill="#DBDBDB" d="m1153.66 352.35.42.138.92-1.16-1.77-2.017-1.42 2.017 1.85 1.022Z"/>
							<path fill="#ECECEC" d="m1150.65 348.592-.23 1.962 1.39.774 1.42-2.017-.44-1.714-2.14.995Z"/>
							<path fill="#E2E2E2" d="m1148.07 345.276 2.58 3.316 2.14-.995-2.59-1.934-2.13-.387Z"/>
							<path fill="#DADADA" d="M1146.99 350.554h3.43l.23-1.962-2.58-3.316-1.55 1.686.47 3.592Z"/>
							<path fill="#D1D1D1" d="M1146.52 345.663v1.299l1.55-1.686-1.47-.276-.08.663Z"/>
							<path fill="#E3E3E3" d="M1141.88 349.034v5.637l5.11-4.117-.47-3.592v-1.299l-4.64 3.371Z"/>
							<path fill="#D8D8D8" d="m1141.88 349.034-4.77 5.057 4.77.58v-5.637Z"/>
							<path fill="#E5E5E5" d="m1134.55 354.588 2.56-.497 4.77-5.057-7.33 5.554Z"/>
							<path fill="#DCDCDC" d="m1136.35 366 4.03-2.128 1.31-2.376-2.16-3.343h-3.29l-3.24 2.984.5 1.271 1.53 3.592h1.32Z"/>
							<path fill="#EEE" d="m1133 361.137 3.24-2.984.87-4.062-2.56.497-1.44 2.542-.11 4.007Z"/>
							<path fill="#D9D9D9" d="m1141.83 366-1.45-2.128-4.03 2.128h5.48Z"/>
							<path fill="#D5D5D5" d="m1145.15 366 3.95-1.768-2.27-1.271-1.68 3.039Z"/>
							<path fill="#E3E3E3" d="M1145.15 366h4.32l-.37-1.768-3.95 1.768ZM1143.25 366h1.9l-1.56-3.73-1.76.829 1.42 2.901Z"/>
							<path stroke="#8A8A8A" stroke-width=".2" d="M1145.15 366h4.32l-.37-1.768m-3.95 1.768 3.95-1.768m-3.95 1.768 1.68-3.039m-1.68 3.039h-1.9l-1.42-2.901m3.32 2.901-1.56-3.73m1.56 3.73-.29-8.124m4.24 6.356-2.27-1.271m0 0-.31-5.085m0 0 1.63-4.642m-1.63 4.642h-1.66m3.29-4.642 2.11-.995 2.79.719.61-.608m-5.51.884-1.16-2.68m6.67 1.796.42.138.92-1.16-1.77-2.017m.43 3.039-1.85-1.022m-1.39-.774h-3.43m3.43 0 .23-1.962m-.23 1.962 1.39.774m-4.82-.774-2.13 7.322m2.13-7.322-5.11 4.117m5.11-4.117-.47-3.592m-4.69 16.137 1.76-.829m-1.76.829-1.45.773m3.21-1.602-1.03-2.349m2.3-2.045-2.3 2.045m0 0-.87 1.575m.87-1.575-.68-5.25m-1.5 9.201 1.45 2.128h-5.48m4.03-2.128-4.03 2.128m4.03-2.128 1.31-2.376m-5.34 4.504h-1.32l-1.53-3.592-.5-1.271m0 0 3.24-2.984m-3.24 2.984.11-4.007 1.44-2.542m1.69 3.565h3.29l2.16 3.343m-5.45-3.343.87-4.062m-2.56.497 2.56-.497m-2.56.497 7.33-5.554m-4.77 5.057 4.77-5.057m-4.77 5.057 4.77.58m0-5.637v5.637m0-5.637 4.64-3.371m0 0v1.299m0-1.299.08-.663 1.47.276m-1.55 1.686 1.55-1.686m0 0 2.58 3.316m-2.58-3.316 2.13.387 2.59 1.934m-2.14.995 2.14-.995m.44 1.714-.44-1.714m.44 1.714-1.42 2.017"/>
						</g>
						<g ref="groupF" filter="url(#f)">
							<rect width="283" height="147" x="1110" y="494" fill="#EDF2FA" rx="15"/>
							<circle cx="1143.5" cy="528.5" r="16.5" fill="#fff"/>
							<rect width="224" height="17" x="1127" y="563" fill="#E2E2E2" rx="8.5"/>
							<rect width="224" height="17" x="1127" y="584" fill="#E2E2E2" rx="8.5"/>
							<rect width="91" height="17" x="1127" y="605" fill="#E2E2E2" rx="8.5"/>
							<path fill="#565656" d="M1245.24 536v-14.546h1.68v5.369h.14c.12-.189.29-.43.51-.724.22-.298.54-.563.95-.795.42-.237.98-.356 1.69-.356.92 0 1.73.23 2.43.689.7.46 1.25 1.111 1.64 1.953.4.843.59 1.838.59 2.983 0 1.156-.19 2.157-.59 3.005-.39.842-.93 1.496-1.63 1.96-.7.459-1.5.689-2.41.689-.7 0-1.26-.116-1.68-.348-.42-.237-.75-.504-.97-.803a9.26 9.26 0 0 1-.53-.753h-.2V536h-1.62Zm1.65-5.455c0 .824.12 1.551.36 2.18.24.625.6 1.115 1.06 1.471.46.35 1.03.525 1.7.525.71 0 1.29-.185 1.76-.554.47-.374.83-.876 1.06-1.506.25-.634.37-1.339.37-2.116 0-.767-.12-1.458-.36-2.074-.23-.62-.58-1.11-1.06-1.47-.47-.365-1.06-.547-1.77-.547-.68 0-1.25.173-1.71.519-.47.34-.82.819-1.06 1.434-.23.611-.35 1.324-.35 2.138ZM1240.27 531.54v-6.449h1.67V536h-1.67v-1.847h-.12c-.25.554-.65 1.025-1.19 1.414-.54.383-1.22.575-2.04.575-.69 0-1.29-.149-1.82-.447-.53-.304-.95-.758-1.25-1.364-.31-.611-.46-1.38-.46-2.308v-6.932h1.68v6.818c0 .795.22 1.43.67 1.903.45.474 1.02.711 1.72.711.41 0 .84-.107 1.27-.32.43-.213.8-.54 1.09-.98.3-.44.45-1.001.45-1.683ZM1230.77 526h-1.76c-.1-.506-.28-.952-.54-1.335a3.694 3.694 0 0 0-.94-.966 4.029 4.029 0 0 0-1.22-.597c-.44-.132-.9-.198-1.39-.198-.88 0-1.68.222-2.39.667-.71.445-1.28 1.101-1.7 1.968-.42.866-.62 1.929-.62 3.188 0 1.26.2 2.323.62 3.189.42.867.99 1.523 1.7 1.968.71.445 1.51.667 2.39.667.49 0 .95-.066 1.39-.199.45-.132.85-.329 1.22-.589a3.652 3.652 0 0 0 1.48-2.308h1.76a5.815 5.815 0 0 1-.72 1.995 5.463 5.463 0 0 1-1.31 1.499c-.52.407-1.1.717-1.75.93-.64.214-1.33.32-2.07.32-1.24 0-2.34-.303-3.31-.909-.96-.606-1.72-1.468-2.28-2.585-.55-1.118-.83-2.443-.83-3.978 0-1.534.28-2.859.83-3.977.56-1.117 1.32-1.979 2.28-2.585.97-.606 2.07-.909 3.31-.909.74 0 1.43.106 2.07.319.65.214 1.23.526 1.75.938.52.407.96.904 1.31 1.491.35.583.59 1.248.72 1.996ZM1211.78 536.228c-1.06 0-1.96-.232-2.72-.696a4.66 4.66 0 0 1-1.76-1.961c-.41-.842-.61-1.823-.61-2.94s.2-2.102.61-2.955c.41-.857.99-1.524 1.72-2.002.74-.483 1.6-.725 2.59-.725.56 0 1.12.095 1.68.284.55.19 1.06.497 1.51.924.46.421.82.98 1.09 1.676.27.696.4 1.553.4 2.571v.71h-8.41v-1.449h6.71c0-.615-.12-1.165-.37-1.648a2.775 2.775 0 0 0-1.04-1.143c-.44-.279-.97-.419-1.57-.419-.67 0-1.25.166-1.74.497-.48.327-.85.753-1.11 1.278a3.763 3.763 0 0 0-.39 1.691v.966c0 .824.14 1.522.42 2.095.29.568.69 1.001 1.2 1.3.51.293 1.11.44 1.79.44.44 0 .83-.062 1.19-.185.36-.128.67-.317.93-.568.26-.256.46-.573.6-.952l1.62.455a3.508 3.508 0 0 1-.86 1.449c-.4.412-.9.734-1.49.966-.59.227-1.26.341-1.99.341ZM1198.9 536.227c-.91 0-1.71-.23-2.41-.689-.69-.464-1.24-1.118-1.63-1.96-.39-.848-.59-1.849-.59-3.005 0-1.145.2-2.14.59-2.983.39-.842.94-1.493 1.64-1.953.7-.459 1.51-.689 2.43-.689.71 0 1.27.119 1.68.356.42.232.74.497.95.795.23.294.4.535.52.724h.14v-5.369h1.68V536h-1.62v-1.677h-.2c-.12.199-.3.45-.52.753-.23.299-.56.566-.98.803-.42.232-.98.348-1.68.348Zm.23-1.506c.67 0 1.24-.175 1.7-.525.47-.356.82-.846 1.06-1.471.24-.629.36-1.356.36-2.18 0-.814-.12-1.527-.35-2.138-.24-.615-.59-1.094-1.05-1.434-.47-.346-1.04-.519-1.72-.519-.71 0-1.31.182-1.78.547-.47.36-.82.85-1.06 1.47a5.892 5.892 0 0 0-.35 2.074c0 .777.12 1.482.36 2.116.24.63.6 1.132 1.07 1.506.47.369 1.06.554 1.76.554ZM1190.03 536v-10.909h1.68V536h-1.68Zm.86-12.727c-.33 0-.61-.112-.85-.334-.23-.223-.35-.49-.35-.803 0-.312.12-.58.35-.802.24-.223.52-.334.85-.334.32 0 .6.111.83.334.24.222.36.49.36.802 0 .313-.12.58-.36.803-.23.222-.51.334-.83.334ZM1186.96 521.454V536h-1.67v-14.546h1.67ZM1180.72 525.091c-.09-.72-.43-1.278-1.04-1.676-.61-.398-1.35-.597-2.23-.597-.65 0-1.21.105-1.69.313-.48.208-.85.495-1.12.859-.27.365-.4.779-.4 1.243 0 .388.09.722.28 1.002.19.274.43.504.72.688.29.18.6.33.92.448.33.114.62.206.89.277l1.48.398c.38.099.8.236 1.26.412.47.175.92.414 1.34.717.44.298.79.682 1.07 1.15.28.469.42 1.044.42 1.726 0 .786-.21 1.497-.62 2.131-.41.634-1 1.139-1.79 1.513-.78.374-1.73.561-2.85.561-1.04 0-1.94-.168-2.7-.504-.76-.337-1.36-.805-1.79-1.407a3.956 3.956 0 0 1-.73-2.095h1.81c.05.549.24 1.004.56 1.364.33.355.74.62 1.23.795.51.171 1.05.256 1.62.256.68 0 1.28-.109 1.81-.327.54-.222.96-.53 1.28-.923.31-.398.46-.862.46-1.392 0-.483-.13-.876-.4-1.179-.27-.303-.63-.549-1.07-.739-.44-.189-.91-.355-1.42-.497l-1.79-.511c-1.14-.327-2.04-.793-2.7-1.399-.66-.606-1-1.4-1-2.38 0-.814.22-1.524.66-2.13.45-.611 1.05-1.085 1.79-1.421.76-.341 1.6-.511 2.53-.511.93 0 1.77.168 2.5.504.72.332 1.3.786 1.73 1.364.43.577.66 1.233.68 1.967h-1.7Z"/>
							<path fill="#E7E7E7" d="m1141.83 536.099 1.76-.829-1.03-2.349-.87 1.575-1.31 2.376 1.45-.773Z"/>
							<path fill="#E9E9E9" d="M1136.24 531.153h3.29l2.16 3.343.87-1.575-.68-5.25-4.77-.58-.87 4.062Z"/>
							<path fill="#D8D8D8" d="m1142.56 532.921 2.3-2.045 2.13-7.322-5.11 4.117.68 5.25Z"/>
							<path fill="#E9E9E9" d="m1146.52 530.876 1.63-4.642-1.16-2.68-2.13 7.322h1.66Z"/>
							<path fill="#EFEFEF" d="m1143.59 535.27 1.56 3.73-.29-8.124-2.3 2.045 1.03 2.349Z"/>
							<path fill="#E2E2E2" d="m1145.15 539 1.68-3.039-.31-5.085h-1.66l.29 8.124Z"/>
							<path fill="#E4E4E4" d="m1148.15 526.234 2.11-.995 2.79.719.61-.608-1.85-1.022-1.39-.774h-3.43l1.16 2.68Z"/>
							<path fill="#DBDBDB" d="m1153.66 525.35.42.138.92-1.16-1.77-2.017-1.42 2.017 1.85 1.022Z"/>
							<path fill="#ECECEC" d="m1150.65 521.592-.23 1.962 1.39.774 1.42-2.017-.44-1.714-2.14.995Z"/>
							<path fill="#E2E2E2" d="m1148.07 518.276 2.58 3.316 2.14-.995-2.59-1.934-2.13-.387Z"/>
							<path fill="#DADADA" d="M1146.99 523.554h3.43l.23-1.962-2.58-3.316-1.55 1.686.47 3.592Z"/>
							<path fill="#D1D1D1" d="M1146.52 518.663v1.299l1.55-1.686-1.47-.276-.08.663Z"/>
							<path fill="#E3E3E3" d="M1141.88 522.034v5.637l5.11-4.117-.47-3.592v-1.299l-4.64 3.371Z"/>
							<path fill="#D8D8D8" d="m1141.88 522.034-4.77 5.057 4.77.58v-5.637Z"/>
							<path fill="#E5E5E5" d="m1134.55 527.588 2.56-.497 4.77-5.057-7.33 5.554Z"/>
							<path fill="#DCDCDC" d="m1136.35 539 4.03-2.128 1.31-2.376-2.16-3.343h-3.29l-3.24 2.984.5 1.271 1.53 3.592h1.32Z"/>
							<path fill="#EEE" d="m1133 534.137 3.24-2.984.87-4.062-2.56.497-1.44 2.542-.11 4.007Z"/>
							<path fill="#D9D9D9" d="m1141.83 539-1.45-2.128-4.03 2.128h5.48Z"/>
							<path fill="#D5D5D5" d="m1145.15 539 3.95-1.768-2.27-1.271-1.68 3.039Z"/>
							<path fill="#E3E3E3" d="M1145.15 539h4.32l-.37-1.768-3.95 1.768ZM1143.25 539h1.9l-1.56-3.73-1.76.829 1.42 2.901Z"/>
							<path stroke="#8A8A8A" stroke-width=".2" d="M1145.15 539h4.32l-.37-1.768m-3.95 1.768 3.95-1.768m-3.95 1.768 1.68-3.039m-1.68 3.039h-1.9l-1.42-2.901m3.32 2.901-1.56-3.73m1.56 3.73-.29-8.124m4.24 6.356-2.27-1.271m0 0-.31-5.085m0 0 1.63-4.642m-1.63 4.642h-1.66m3.29-4.642 2.11-.995 2.79.719.61-.608m-5.51.884-1.16-2.68m6.67 1.796.42.138.92-1.16-1.77-2.017m.43 3.039-1.85-1.022m-1.39-.774h-3.43m3.43 0 .23-1.962m-.23 1.962 1.39.774m-4.82-.774-2.13 7.322m2.13-7.322-5.11 4.117m5.11-4.117-.47-3.592m-4.69 16.137 1.76-.829m-1.76.829-1.45.773m3.21-1.602-1.03-2.349m2.3-2.045-2.3 2.045m0 0-.87 1.575m.87-1.575-.68-5.25m-1.5 9.201 1.45 2.128h-5.48m4.03-2.128-4.03 2.128m4.03-2.128 1.31-2.376m-5.34 4.504h-1.32l-1.53-3.592-.5-1.271m0 0 3.24-2.984m-3.24 2.984.11-4.007 1.44-2.542m1.69 3.565h3.29l2.16 3.343m-5.45-3.343.87-4.062m-2.56.497 2.56-.497m-2.56.497 7.33-5.554m-4.77 5.057 4.77-5.057m-4.77 5.057 4.77.58m0-5.637v5.637m0-5.637 4.64-3.371m0 0v1.299m0-1.299.08-.663 1.47.276m-1.55 1.686 1.55-1.686m0 0 2.58 3.316m-2.58-3.316 2.13.387 2.59 1.934m-2.14.995 2.14-.995m.44 1.714-.44-1.714m.44 1.714-1.42 2.017"/>
						</g>
							<defs>
							<filter id="c" width="614" height="163" x="0" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
								<feFlood flood-opacity="0" result="BackgroundImageFix"/>
								<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
								<feOffset dy="4"/>
								<feGaussianBlur stdDeviation="3.5"/>
								<feComposite in2="hardAlpha" operator="out"/>
								<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
								<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_73_538"/>
								<feBlend in="SourceGraphic" in2="effect1_dropShadow_73_538" result="shape"/>
							</filter>
							<filter id="d" width="291" height="172" x="1106" y="131" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
								<feFlood flood-opacity="0" result="BackgroundImageFix"/>
								<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
								<feOffset dy="4"/>
								<feGaussianBlur stdDeviation="2"/>
								<feComposite in2="hardAlpha" operator="out"/>
								<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
								<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_73_538"/>
								<feBlend in="SourceGraphic" in2="effect1_dropShadow_73_538" result="shape"/>
							</filter>
							<filter id="e" width="291" height="155" x="1106" y="321" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
								<feFlood flood-opacity="0" result="BackgroundImageFix"/>
								<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
								<feOffset dy="4"/>
								<feGaussianBlur stdDeviation="2"/>
								<feComposite in2="hardAlpha" operator="out"/>
								<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
								<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_73_538"/>
								<feBlend in="SourceGraphic" in2="effect1_dropShadow_73_538" result="shape"/>
							</filter>
							<filter id="f" width="291" height="155" x="1106" y="494" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
								<feFlood flood-opacity="0" result="BackgroundImageFix"/>
								<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
								<feOffset dy="4"/>
								<feGaussianBlur stdDeviation="2"/>
								<feComposite in2="hardAlpha" operator="out"/>
								<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
								<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_73_538"/>
								<feBlend in="SourceGraphic" in2="effect1_dropShadow_73_538" result="shape"/>
							</filter>
							<linearGradient id="a" x1="706.5" x2="706.5" y1="131" y2="587" gradientUnits="userSpaceOnUse">
								<stop stop-color="#B4AFEF"/>
								<stop offset="1" stop-color="#B4AFEF" stop-opacity="0"/>
							</linearGradient>
							<linearGradient id="b" x1="208.5" x2="208.5" y1="247.001" y2="350.503" gradientUnits="userSpaceOnUse">
								<stop stop-color="#B4AFEF"/>
								<stop offset="1" stop-color="#B4AFEF" stop-opacity="0"/>
							</linearGradient>
						</defs>
					</svg>

				</div>
			</div>


			<!-- Features of Review -->
			<div class="mx-auto max-w-7xl mt-12 md:mt-16 lg:px-8">
				<div class="flex flex-col items-center justify-center space-y-4 sm:space-y-6 mb-8 sm:mb-12">
					<!-- Icon container with professional styling -->
					<div class="flex h-16 w-16 items-center justify-center rounded-xl bg-gray-50 border border-gray-200 shadow-sm">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-8 w-8 text-gray-600">
							<path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
						</svg>
					</div>

					<!-- Title with professional typography -->
					<h2 class="text-center text-3xl sm:text-4xl font-funnel leading-tight text-gray-900 tracking-tight max-w-4xl">
						AI that looks at all the details
					</h2>

					<!-- Subtle decorative line -->
					<div class="w-24 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
				</div>


				 <Features />
			</div>


		</main>




	<div class="py-12 sm:py-24">
		<div class="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">

			<div class="flex flex-col items-center justify-center space-y-4 sm:space-y-6 mb-8 sm:mb-12">
				<!-- Icon container with professional styling -->
				<div class="flex h-16 w-16 items-center justify-center rounded-xl bg-gray-50 border border-gray-200 shadow-sm">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke-width="1.5" stroke="currentColor" class="h-8 w-8 text-gray-600" viewBox="0 0 24 24">
						<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m10.05 10.607-7.07 7.07a2 2 0 0 0 0 2.83v0a2 2 0 0 0 2.828 0l7.07-7.072M17.193 13.8l3.878 3.878a2 2 0 0 1 0 2.828v0a2 2 0 0 1-2.828 0l-6.209-6.208M6.733 5.904 4.61 6.61 2.49 3.075l1.414-1.414L7.44 3.782l-.707 2.122Zm0 0 2.83 2.83"/>
						<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10.05 10.607c-.844-2.153-.679-4.978 1.061-6.718 1.74-1.74 4.95-2.121 6.717-1.06l-3.04 3.04-.283 3.111 3.111-.282 3.04-3.041c1.062 1.768.68 4.978-1.06 6.717-1.74 1.74-4.564 1.905-6.717 1.061"/>
					</svg>
				</div>

				<!-- Title with professional typography -->
				<h2 class="text-center text-3xl sm:text-4xl font-funnel leading-tight text-gray-900 tracking-tight max-w-4xl">
					Other tools to build better slides
				</h2>

				<!-- Subtle decorative line -->
				<div class="w-24 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
			</div>

			<div class="mt-10 grid gap-4 sm:mt-16 lg:grid-cols-3 sm:grid-cols-1">
				<div class="relative">
					<div class="absolute inset-px rounded-lg bg-white lg:rounded-l-[2rem]" />
					<div class="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-l-[calc(2rem+1px)] border transition-colors hover:border-gray-400">
						<Link href="/icons">
							<div class="px-8 pb-3 pt-8 sm:px-10 sm:pb-0 sm:pt-10 group">
								<span class="">
									<p class="mt-2 text-xl font-funnel tracking-tight text-gray-950 max-lg:text-center">Vector Icons</p>
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
										 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
										 stroke-linejoin="round"
										 class="absolute top-8 right-8 -rotate-45 stroke-1 -translate-x-1 translate-y-1 opacity-0 transition-all group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0">
										<path d="M5 12h14"></path>
										<path d="m12 5 7 7-7 7"></path>
									</svg>

								</span>
								<p class="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">One-click, copy/ paste icons as vector shapes. 2000+ icons and counting. Try it out below.</p>
							</div>
						</Link>

						<IconGalleryMini :icons="icons"/>

					</div>
<!--					<div class="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-l-[2rem]" />-->
				</div>
				<div class="relative max-lg:row-start-1 sm:col-span-2 group">
					<div class="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem] lg:rounded-r-[calc(2rem+1px)] border transition-colors group-hover:border-gray-400" />
					<div class="relative flex flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)]  ">
						<Link href="/repository">
							<div class="px-8 pt-8 sm:px-10 sm:pt-10 group/headings">
									<p class="mt-2 text-xl font-funnel tracking-tight text-gray-950 max-lg:text-center">Slide Repository</p>
									<p class="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">The missing organization layer for slides. Store, find, and re-use collections of saved slides and corporate templates to quickly scaffold your next presentation.</p>
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
										 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
										 stroke-linejoin="round"
										 class="absolute top-8 right-8 -rotate-45 stroke-1 -translate-x-1 translate-y-1 opacity-0 transition-all group-hover/headings:opacity-100 group-hover/headings:translate-x-0 group-hover/headings:translate-y-0">
										<path d="M5 12h14"></path>
										<path d="m12 5 7 7-7 7"></path>
									</svg>
							</div>
						</Link>

						<SlideRepositoryMini />

					</div>
				</div>
			</div>
		</div>
	</div>

	</div> <!-- this is the end of the checkered bg -->



	<Footer />


</template>

<script setup>

// shadcn imports
import { Button } from '@/Components/ui/button'
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/Components/ui/dialog'
import { Input } from '@/Components/ui/input'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/Components/ui/accordion'


const screenSize = ref(window.innerWidth);


const reviewPreflightModalOpen = ref(false); // this is the "preflight" / you aren't logged in modal
const reviewStartedModalOpen = ref(false); // this is the "we've kicked off the review job" modal that you get after preflight or directly if you're logged in
const reviewStartedModalOpenedForFirstTime = ref(false); // this is the "we've kicked off the review job" modal that you get after preflight or directly if you're logged in
const presentationURLValidationHasError = ref(false);
const presentationURLValidationError = ref(null);
const attrs = useAttrs(); // Access component attributes

const drivePickerOpen = ref(false);


const lastUsed = ref(null);
const auth_token = ref(null);

onMounted(() => {

	// if they've logged in before, set that value
	const storedValue = localStorage.getItem('lastUsed');
	if (storedValue) {
		lastUsed.value = storedValue;
	}

	// if they are logged in, set the auth_token
	auth_token.value = attrs.auth?.user?.google_auth_account?.access_token;

	// if there's a query param with a presentation, set that as the presentationURL immediately
	let params = new URLSearchParams(document.location.search);
	let presentationViaParam = params.get('presentation');

	if (presentationViaParam === 'not_specified') {
		validateAndOpenPreflightModal(); // this means no URL was passed, so just open the picker anyway
	} else {
		presentationURL.value = presentationViaParam ?? null; // since the param is a real URL
	}
	// clean up the URL to remove the passed value so a reload doesn't break
	setTimeout(() => {
		window.history.replaceState({}, '', window.location.origin + window.location.pathname);
	}, 10);

});

const drivePickerAlreadyOpened = ref(false)
// set the pickerLoading, so I can render a loading icon while the Picker actually loads
const pickerLoading = ref(false);

// this is to make sure I leave the actual picker element rendered in the background
watch(drivePickerOpen, (newVal) => {
	if (newVal) {
		drivePickerAlreadyOpened.value = true

		pickerLoading.value = true
		// Non-blocking wait
		setTimeout(() => {
			pickerLoading.value = false
		}, 2000)

	}
})

const preAuthGuideOpen = ref(false);
function validateAndOpenPreflightModal() {

	if(!attrs.auth.user?.isGuest) {
		console.log("they are logged in");
		// there is a user logged in so just open the modal
		drivePickerOpen.value = true;
	} else if (lastUsed.value) {
		// no one logged in, but we've seen them before
		// this means they probably have an account
		// so prompt them to login first
		reviewPreflightModalOpen.value = true;
	} else {
		console.log("is a guest");
		preAuthGuideOpen.value = true;
		// you probably haven't been here so just open the picker and let it handle full auth
		// drivePickerOpen.value = true;
	}

}

const presentationURL = ref(null);


import {computed, nextTick, onMounted, onUnmounted, ref, useAttrs, watch} from "vue";
import { useMotion } from '@vueuse/motion'
import { Link } from "@inertiajs/vue3";
import Navigation from "@/Pages/Homepage/cards/Navigation.vue";
import GoogleDrivePicker from "@/Components/GoogleDrivePicker.vue";
import ApplicationLogo from "@/Components/ApplicationLogo.vue";
import SlideRepositoryMini from "@/Pages/Homepage/cards/SlideRepositoryMini.vue";
import IconGalleryMini from "@/Pages/Homepage/cards/IconGalleryMini.vue";
import Features from "@/Pages/Homepage/cards/Features.vue";
import Footer from "@/Pages/Homepage/cards/Footer.vue";

// animate comments into place
const groupD = ref(null)
const groupE = ref(null)
const groupF = ref(null)

useMotion(groupD, {
	initial: { opacity: 0, y: 100 },
	enter: { opacity: 1, y: 0, transition: { delay: 2000 } },
})

useMotion(groupE, {
	initial: { opacity: 0, y: 50 },
	enter: { opacity: 1, y: 0, transition: { delay: 3000 } },
})

useMotion(groupF, {
	initial: { opacity: 0, y: 50 },
	enter: { opacity: 1, y: 0, transition: { delay: 3800 } },
})

// animate presentation title changing

const presentationTitlesvg = ref('Business Plan Q1');
const titles = ["Investor Q4 Update", "Client Proposal", "Class Presentation", "Q2 Roadmap Review", "Company All Hands", "Status Report", "Client Onsite Workshop", "RFP Clarifications", "Product Introduction", "New Market Expansion Proposal","Business Plan Q1"];
const textElement = ref(null);
let index = 0;

const { apply, stop } = useMotion(textElement, {
	initial: { opacity: 0, y: 15 },
	enter: { opacity: 1, y: 0, transition: { duration: 400 } },
	leave: { opacity: 0, y: -15, transition: { duration: 400 } },
});

onMounted(() => {
	setInterval(() => {
		apply("leave"); // Animate out
		setTimeout(() => {
			presentationTitlesvg.value = titles[index]; // Change text
			index = (index + 1) % titles.length;
			apply("enter"); // Animate in
		}, 400); // Matches the duration of the leave animation
	}, 5000);
});


// simulate LLM adding the subtitle

const fullText = `Get an expert review in 60 seconds, with comments directly in your presentation. It's like a second pair of eyes before <span class="font-mono">vFinal</span>`;
const words = ref([]);
const displayedText = ref("");
const showCursor = ref(true);

let animationTimeout = null;

const animate = (words, index = 0) => {
	if (index >= words.length) {
		showCursor.value = false;
		return;
	}

	// Randomly decide whether to add 1 or 2 words
	const numWordsToAdd = Math.random() < 0.5 ? 1 : 2;

	// Add the words
	for (let i = 0; i < numWordsToAdd && index < words.length; i++) {
		displayedText.value += (index === 0 ? "" : " ") + words[index];
		index++;
	}

	// Schedule next update with random delay
	const delay = Math.floor(Math.random() * (75 - 25 + 1)) + 50;
	animationTimeout = setTimeout(() => animate(words, index), delay);
};

onMounted(() => {
	const words = fullText.split(" ");
	animate(words);
});

onUnmounted(() => {
	if (animationTimeout) {
		clearTimeout(animationTimeout);
	}
	showCursor.value = false;
});

//


const isPresentationURLValid = computed(() => {
	return /docs\.google\.com\/presentation/.test(presentationURL.value);
});

// Watch for changes in isPresentationURLValid and take action when it becomes true
watch(isPresentationURLValid, (newValue) => {
	if (newValue) { // if TRUE, as in, the presentation URL is valid
		validateAndOpenPreflightModal();
	}
});

const presentationThumbnail = ref();
const presentationMetadata = ref({
	title: '',
	lastEditedLocal: '',
	id: '',
	slide_count: null,
	skipped_slides: null,
	url: '',
	message:'Your AI review is starting now.',
	warning: null,

});

watch(reviewStartedModalOpen, (newValue) => {
	if (newValue) { // if TRUE, as in, the modal has been opened

		reviewStartedModalOpenedForFirstTime.value = true;

	}
});


function startAIReview(pickerPayload,accessToken) {

	// open the "started" modal
	reviewStartedModalOpen.value = true;
	reviewStartedModalOpenedForFirstTime.value = true;

	// pass known information about the presentation immediately
	presentationMetadata.value.title = pickerPayload.docs[0].name;
	presentationMetadata.value.url = pickerPayload.docs[0].url;

	const datetime = new Date(pickerPayload.docs[0].lastEditedUtc);
	presentationMetadata.value.lastEditedLocal = datetime.toLocaleString();

	presentationMetadata.value.id = pickerPayload.docs[0].id;


	axios.post('/presentation/review/start', {
		presentation: pickerPayload,
		accessToken: accessToken
	})
		.then((response) => {
			// update metadata
			presentationThumbnail.value = response.data.thumbnailURL;
			presentationMetadata.value.slide_count = response.data.metadata.slides;
			presentationMetadata.value.skipped_slides = response.data.metadata.skipped_slides;
			presentationMetadata.value.message = response.data.message;
			presentationMetadata.value.warning = response.data.warning || null;

		})
		.catch((error) => {
			console.log("Failed to start AI review for this reason:");
			console.log(error);
			alert('Looks like we had an issue starting an AI review. This has been logged and will be investigated.');
		});

}

// -------- code for carousel of icons


const props = defineProps({
	icons: Array,
	google_client_id: String,
});

function closeAllModals() {
	preAuthGuideOpen.value = false;
	reviewPreflightModalOpen.value = false;
}



</script>

<style scoped>

</style>